import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class PageCinemagraphSplash extends Component {
  		
	render() {
		
		let block = this.props.block;
		
		if (block) {

			return (				
				
				<div className={'c-page__block c-page__block--splash c-page__block--space-' + block.space_after}>
					<div className="c-cinemagraph-splash">
						<div className="c-cinemagraph-splash__inner" dangerouslySetInnerHTML={{__html:'<video src="' + block.video + '" autoplay loop playsinline muted></video>'}}></div>
						<p className="c-cinemagraph-splash__text" dangerouslySetInnerHTML={{__html:block.text}}></p>
					</div>
				</div>
									
			);
			
		} else {
			return null;
		}
	}
}